import React from "react";
import { Box, Typography } from "@mui/material";
import FadedAgentArt, { AGENT_BG_INSET, agentArtSize } from "./FadedAgentArt";

export const PLAYED_AGENT_SIZE = 64;
export const PLAYED_AGENT_ZOOM = 1.32;
export const PLAYED_AGENT_OVERLAP = 30;

export function playedAgentSlot(size = PLAYED_AGENT_SIZE, zoom = PLAYED_AGENT_ZOOM) {
    return AGENT_BG_INSET + agentArtSize(size, zoom);
}

export function playedAgentsColumnWidth(
    count = 3,
    size = PLAYED_AGENT_SIZE,
    zoom = PLAYED_AGENT_ZOOM,
    overlap = PLAYED_AGENT_OVERLAP,
) {
    const slot = playedAgentSlot(size, zoom);
    return slot + Math.max(0, count - 1) * (slot - overlap);
}

export default function PlayedAgents({
    agents,
    size = PLAYED_AGENT_SIZE,
    zoom = PLAYED_AGENT_ZOOM,
    overlap = PLAYED_AGENT_OVERLAP,
}: {
    agents: string[];
    size?: number;
    zoom?: number;
    overlap?: number;
}) {
    if (!agents.length) {
        return (
            <Typography sx={{ fontSize: "0.62rem", color: "rgba(255,255,255,0.28)", fontWeight: 600 }}>
                —
            </Typography>
        );
    }
    const slot = playedAgentSlot(size, zoom);
    return (
        <Box
            sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
            }}
        >
            {agents.map((agent, index) => (
                <Box
                    key={agent}
                    sx={{
                        position: "relative",
                        width: slot,
                        minWidth: slot,
                        height: "100%",
                        flexShrink: 0,
                        ml: index === 0 ? 0 : `-${overlap}px`,
                    }}
                    style={{ zIndex: agents.length - index }}
                >
                    <FadedAgentArt
                        agent={agent}
                        size={size}
                        zoom={zoom}
                        asBackground
                        fade={index === 0 ? "soft" : index === agents.length - 1 ? "right" : "left"}
                        zIndex="auto"
                    />
                </Box>
            ))}
        </Box>
    );
}
